import { createTheme } from '@mui/material/styles';

/**
 * Mbaa Mwendwa brand: emerald green and white.
 * One color, its shades, and breathing room — like the tree itself.
 */
export const BRAND = {
  primary: '#059669',        // emerald
  primaryDark: '#065F46',    // deep emerald (hover, emphasis)
  primaryHover: '#047857',
  primaryLight: '#D1FAE5',   // whisper-green backgrounds
};

const theme = createTheme({
  palette: {
    primary: { main: BRAND.primary, dark: BRAND.primaryHover, light: BRAND.primaryLight, contrastText: '#ffffff' },
    secondary: { main: BRAND.primaryDark },
    background: { default: '#fafafa' },
  },
  shape: { borderRadius: 10 },
  components: {
    // Every filled button in the app speaks white — including custom
    // gradient backgrounds, Fabs, and disabled states
    MuiButton: {
      styleOverrides: {
        contained: {
          color: '#ffffff',
          '&.Mui-disabled': {
            color: '#ffffff',
            backgroundColor: '#A7D9C4',
          },
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: { color: '#ffffff' },
      },
    },
  },
  typography: {
    fontFamily: "'Roboto', sans-serif",
    button: { textTransform: 'none', fontWeight: 600 },
  },
});

export default theme;
